import React from 'react';

import { Button, Tooltip, Typography } from 'antd';

import { ApartmentOutlined } from '@ant-design/icons';

import { StyledModal } from 'common/components';
import { IXOneHierarchyModal } from './IXOneHierarchyModal';

import { useVisibleModal } from 'hooks';
import { modalIXOneCaptureWidth } from '../ixone-credit-card';

export const IXOneHierarchyAction = ({
  productId,
  productName,
  hierarchies,
  ...otherProps
}) => {
  const [
    visibleListHierarchyModal,
    { onModal: onModalListHierarchy, offModal: offModalListHierarchy },
  ] = useVisibleModal();

  const modalProps = {
    title: (
      <>
        <Typography.Text>Hierarchies for product </Typography.Text>
        <Typography.Link href={`/product/${productId}`} target='_blank'>
          {productName}
        </Typography.Link>
      </>
    ),

    visible: visibleListHierarchyModal,
    onCancel: offModalListHierarchy,
    bodyStyle: {
      minHeight: 400,
      maxHeight: 600,
      paddingTop: 4,
    },
    width: modalIXOneCaptureWidth,
    closable: true,
    maskClosable: false,
    destroyOnClose: false,
    ...otherProps,
  };

  return (
    <>
      <Tooltip title='Change Hierarchy'>
        <Button
          type='primary'
          style={{ border: 'none', borderRadius: 4 }}
          icon={<ApartmentOutlined />}
          onClick={onModalListHierarchy}
        />
      </Tooltip>
      {visibleListHierarchyModal && (
        <StyledModal
          {...modalProps}
          loadingContent={{ loadingText: 'Loading' }}
          footer={null}
        >
          <IXOneHierarchyModal
            productId={productId}
            hierarchies={hierarchies}
            offModalListHierarchy={offModalListHierarchy}
          />
        </StyledModal>
      )}
    </>
  );
};
